import React from "react";

import styled from "styled-components";
import blanformImg from "assets/image/products/blanform_tmb.png";
import syringepumpImg from "assets/image/products/syringepump_tmb.png";
import clinterboxImg from "assets/image/products/clinterbox_tmb.png";
import { useNavigate } from "react-router-dom";

export default function ProductBanner() {
  const navigate = useNavigate();
  const ProductBanner = styled.div`
    width: 100%;
    padding: 80px 50px;

    display: flex;
    flex-direction: column;
    gap: 30px;

    align-items: center;
  `;

  const TitleContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;

    & > div:first-child {
      font-size: 22px;
      font-weight: lighter;
    }

    & > div:nth-child(2) {
      font-size: 28px;
      font-weight: bold;
    }

    & > div:nth-child(3) {
      height: 1px;
      width: 80px;
      border-bottom: solid 2px var(--color-blueblack);
    }
  `;

  const ItemContainer = styled.div`
    width: 100%;

    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  `;

  const Item = styled.div`
    width: 30%;
    padding: 30px;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;

    cursor: pointer;

    &:hover {
      background-color: var(--color-grey);
    }

    & > img {
      width: 100%;
    }

    & > div {
      width: 100px;
      height: 30px;

      text-align: center;
      line-height: 30px;

      font-size: var(--font-size-title);

      border: 1px solid var(--color-grey);
    }
  `;

  const ee = (link) => {
    navigate("/product" + link);
  };

  return (
    <ProductBanner>
      <TitleContainer>
        <div>MAIN PRODUCT</div>
        <div>주요 제품</div>
        <div />
      </TitleContainer>
      <ItemContainer>
        <Item onClick={(e) => ee("/blanform/item", e)}>
          <img src={blanformImg} alt="blanform_tmb" />
          <div>블랜폼</div>
        </Item>
        <Item onClick={(e) => ee("/syringepump/item", e)}>
          <img src={syringepumpImg} alt="syringepump_tmb" />
          <div>시린지펌프</div>
        </Item>
        <Item onClick={(e) => ee("/cleanterbox/item", e)}>
          <img src={clinterboxImg} alt="clinterbox_tmb" />
          <div>클린터박스</div>
        </Item>
      </ItemContainer>
    </ProductBanner>
  );
}
